import script from "./CategoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryModal.vue?vue&type=script&setup=true&lang=js"

import "./CategoryModal.vue?vue&type=style&index=0&id=ccf2ccb4&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccf2ccb4"]])

export default __exports__